"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newUserPostRequest = newUserPostRequest;
exports.newGroupPostRequest = newGroupPostRequest;
async function newUserPostRequest(payload) {
    const data = new URLSearchParams({
        name: payload.name,
        furigana: payload.furigana,
        phone: payload.phone,
    });
    if (payload.email) {
        data.append("email", payload.email);
    }
    if (payload.phone) {
        data.append("SMSVerified", "1");
    }
    try {
        const res = await fetch(`/dashboard/${payload.id}/user`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: data.toString(),
        });
        if (!res.ok) {
            throw new Error();
        }
        return res;
    }
    catch (err) {
        throw err;
    }
}
async function newGroupPostRequest(userId, payload, selectedFeatures) {
    const data = {
        name: payload.name,
        address: payload.address,
        category: payload.category || 0,
        expectedUsers: payload.numOfExpectedUsers || 0,
        expectedBranches: payload.numOfExpectedBranches || 0,
        referrer: payload.referrer || 0,
        selectedFeatures,
    };
    try {
        const res = await fetch(`/dashboard/${userId}/company`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });
        if (!res.ok) {
            throw new Error();
        }
    }
    catch (err) {
        throw err;
    }
}
